import { Modal, ModalContent, ModalTrigger } from 'src/shared/ui/components/Modal';
import { ModalContentActions } from 'src/shared/ui/components/Modal';

import { Button } from '@shared/ui/components/Button';
import { Icon } from '@shared/ui/components/Icon';
import { useToast } from '@shared/ui/components/Toast';

type DataTableDeleteButtonProps = {
  refresh: () => void;
  onDelete: () => Promise<void> | void;
};

export function DataTableDeleteButton({ onDelete, refresh }: DataTableDeleteButtonProps) {
  const { toast } = useToast();

  async function handleDelete(): Promise<void> {
    try {
      await onDelete();
    } catch (error: any) {
      if (error.response) {
        toast({
          title: 'Error',
          description: error.response.data?.message,
          variant: 'destructive',
        });
      } else {
        toast({
          title: 'Error',
          description: 'An unknown error occurred.',
          variant: 'destructive',
        });
      }
    } finally {
      refresh();
    }
  }

  return (
    <Modal>
      <ModalTrigger asChild>
        <Button variant="outline-destructive" size="sm" title="Delete">
          <Icon icon="trash" />
        </Button>
      </ModalTrigger>
      <ModalContent title="Delete">
        <p>Are you sure you want to delete this?</p>
        <ModalContentActions onConfirm={handleDelete} />
      </ModalContent>
    </Modal>
  );
}
